export default "__VITE_ASSET__118e4679__"